import {
  Box,
  Button,
  CircularProgress,
  Typography,
  useTheme
} from '@mui/material';
import { blogPostStepper } from '../blogPostIdeas/blogPostCss';
import { useNavigate } from 'react-router';
import { buySearchCreditTexts, userRoles } from 'src/common/config/TextMessage';
import { useDispatch, useSelector } from 'react-redux';
import { UpgradeAgencyModalTexts } from 'src/content/onBoarding/AllTexts';
import { buySearchCreditModalSxs } from '../keywordResearchCSS';
import { RootState } from 'src/redux/store';
import {
  KeywordTrackingAllCss,
  keywordTrackingUpgradeSx
} from './KeywordTrackingAllCss';
import { keywordTrackingUpgradeTexts } from './KeywordTrackingAllTexts';
import { UpgradeAgencyPlanModalSxs } from 'src/content/onBoarding/UpgradeAgencyPlanModalSx';
import { openNewTab } from 'src/common/config/FunctionHelper';
import { setIsAgencyUpgrade } from 'src/redux/keywordResearch';
import { useEffect, useState } from 'react';
import {
  getPlanDetails,
  getCreditDetails,
  getSubscriptionDetailsStripe,
  upgradeDowngradePlan
} from 'src/common/Scraper';
import { setStateStripeSubscription } from 'src/redux/userReducer';
import { setIsAgencyMonitoring } from 'src/redux/dashboard';
import CommonAlert from 'src/common/CommonAlert';
import {
  BackLinkAllTexts,
  LocalSeoInfoBoxTexts
} from 'src/content/OtherTools/BackLinkAllTexts';
import CommonModal from 'src/common/config/CommonModal';
import { UpgradeAgencyPlanModal } from 'src/content/onBoarding/UpgradeAgencyPlanModal';
import { localSeoTexts } from 'src/content/localSeo/localSeoTexts';
import { MapRankTexts } from 'src/content/mapRankTracker/MapRankTexts';
import { LocalSeoAllSx } from 'src/content/localSeo/localSeoCss';
import {
  AiDashboardTexts,
  AIVisibilityAddOnModalWidth
} from 'src/content/aiVisibility/utils/texts';
import { AiVisibilityAddonModal } from 'src/content/aiVisibility/AiVisibilityAddonModal';
import { updateSearchesDetailsAndLimits } from 'src/common/config/FunctionHelperPartTwo';

export const UpgradeToAgency = ({
  getKeywordTrackingFunc = () => {},
  isBackLink = false,
  isLocalSeo = false,
  isMapRankTracking = false,
  isLocalSeoTask = false,
  isPosting = false,
  isListing = false,
  isReviews = false,
  isAiVisibility = false
}) => {
  const [loader, setLoading] = useState(false);
  const [responseMessage, setResponseMessage]: any = useState(null);
  const [planId, setPlanId]: any = useState(null);
  const [planInterval, setPlanInterval]: any = useState(null);
  const [openModal, setOpenModal]: any = useState(null);
  const [isBackLinkUnlock, setIsBackLinkUnlock]: any = useState(null);
  const [isKeywordUnlock, setIsKeywordUnlock]: any = useState(null);
  const [isLocalSeoUnlock, setIsLocalSeoUnlock]: any = useState(null);
  const [openAiAddonModal, setOpenAiAddonModal]: any = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme(); // Access the theme
  const styles = buySearchCreditModalSxs(theme);
  let userDetails: any = useSelector(
    (state: RootState) => state.counter.userDetails
  );
  let subscriptionDetails: any =
    useSelector((state: RootState) => state.user.subscription) ?? {};
  const isMember = userDetails?.role_type === userRoles?.member;

  useEffect(() => {
    if (subscriptionDetails) {
      setPlanInterval(subscriptionDetails?.interval);
    }
  }, [subscriptionDetails]);

  const getAllPlanDetails = async () => {
    const getAllPlanResponse: any = await getPlanDetails();
    const allPlans = getAllPlanResponse?.plans || [];

    // Get the first matching plan with a monthly interval
    const monthlyData = allPlans.find(
      (plan) => plan.recurring?.interval === 'month'
    );

    // Get the first matching plan with a yearly interval
    const yearlyData = allPlans.find(
      (plan) => plan.recurring?.interval === 'year'
    );
    if (planInterval === 'year') {
      setPlanId(yearlyData?.id);
      if (!yearlyData?.id) {
        setLoading(false);
      }
    } else {
      setPlanId(monthlyData?.id);
      if (!monthlyData?.id) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (planId) {
      upgradePlan();
    }
  }, [planId]);

  const upgradePlan = async () => {
    const payload = {
      email: userDetails?.email || '',
      subscription_id: subscriptionDetails?.subscription_id,
      planId,
      type: 'Upgrade',
      downgradeFeedback: '',
      siteIds: []
    };
    const upgradeDowngradePlanResponse: any = await upgradeDowngradePlan(
      payload
    );

    if (upgradeDowngradePlanResponse?.status == 'success') {
      await getSubScriptionDetails();
    }
    setResponseMessage({
      status: upgradeDowngradePlanResponse?.status,
      message: upgradeDowngradePlanResponse?.message
    });

    setTimeout(() => {
      setLoading(null);
      setResponseMessage(null);
    }, 3000);
  };

  const getSubScriptionDetails = async () => {
    const subscriptionDetailsStripe = await getSubscriptionDetailsStripe();
    if (subscriptionDetailsStripe != undefined) {
      getSearchesDetail();
      dispatch(setIsAgencyMonitoring(true));
      dispatch(setIsAgencyUpgrade(true));
      dispatch(setStateStripeSubscription(subscriptionDetailsStripe));
      setTimeout(() => {
        dispatch(setIsAgencyUpgrade(false));
      }, 3000);
    } else {
      dispatch(setStateStripeSubscription({}));
    }
  };

  const handleUpgradeClick = async () => {
    setLoading(true);
    await getAllPlanDetails();
  };

  const getSearchesDetail = async () => {
    let getSearchesDetail: any = await getCreditDetails();

    if (getSearchesDetail) {
      updateSearchesDetailsAndLimits(getSearchesDetail);
    }
  };

  const handleCloseUpgradeModal = () => {
    setOpenModal(false);
    setTimeout(() => {
      setIsBackLinkUnlock(false);
      setIsKeywordUnlock(false);
      setIsLocalSeoUnlock(false);
    }, 500);
  };

  const handleAiAddonModalClose = () => {
    setOpenAiAddonModal(false);
  };

  return (
    <>
      <Typography sx={keywordTrackingUpgradeSx?.keywordTrackingTextSx}>
        {isAiVisibility
          ? AiDashboardTexts?.title
          : isPosting
          ? localSeoTexts?.localSeoPostingTitle
          : isLocalSeoTask
          ? localSeoTexts?.localSeoTaskUpgradeTitle
          : isMapRankTracking
          ? MapRankTexts?.upgradeTitle
          : isListing
          ? localSeoTexts?.listingUpgradeTitle
          : isReviews
          ? localSeoTexts?.reviewsUpgradeTitle
          : isLocalSeo
          ? localSeoTexts?.upgradeTitle
          : isBackLink
          ? BackLinkAllTexts?.backLinkAnalysis
          : keywordTrackingUpgradeTexts?.keywordTracking}
      </Typography>
      <Box sx={KeywordTrackingAllCss?.keywordTrackingToolBox}>
        <Typography sx={keywordTrackingUpgradeSx?.unlockTextSx}>
          {isAiVisibility
            ? AiDashboardTexts?.upgradePageTitle
            : isPosting
            ? localSeoTexts?.localSeoPostingMainDesc
            : isLocalSeoTask
            ? localSeoTexts?.localSeoTaskUpgradeMainDesc
            : isMapRankTracking
            ? MapRankTexts?.upgradeDesc
            : isLocalSeo
            ? localSeoTexts?.upgradeDesc
            : isBackLink
            ? BackLinkAllTexts?.unlock
            : keywordTrackingUpgradeTexts?.unlock}
        </Typography>
        <Typography sx={keywordTrackingUpgradeSx?.descSx}>
          {isAiVisibility
            ? AiDashboardTexts?.upgradePageDesc
            : isPosting
            ? localSeoTexts?.localSeoPostingSubDesc
            : isLocalSeoTask
            ? localSeoTexts?.localSeoTaskUpgradeDesc
            : isMapRankTracking
            ? MapRankTexts?.upgradeSubDesc
            : isLocalSeo
            ? localSeoTexts?.unlockDesc
            : isBackLink
            ? BackLinkAllTexts?.unlockDesc
            : keywordTrackingUpgradeTexts?.desc}
        </Typography>
        {isMapRankTracking && (
          <Box
            sx={{
              justifyContent: 'center',
              marginTop: '12px',
              ...UpgradeAgencyPlanModalSxs?.learnMoreBoxSx
            }}
          >
            <Typography
              onClick={() => {
                openNewTab(LocalSeoInfoBoxTexts?.seoToolsLink);
              }}
              sx={UpgradeAgencyPlanModalSxs?.learnMoreSx}
            >
              {UpgradeAgencyModalTexts?.learnMore}
            </Typography>
            <img
              draggable={false}
              src={
                process.env.PUBLIC_URL +
                `/static/images/icons/green-up-icon.svg`
              }
              alt="Check Icon"
              onClick={() => {
                openNewTab(LocalSeoInfoBoxTexts?.seoToolsLink);
              }}
              style={UpgradeAgencyPlanModalSxs?.greenUpImgStyle}
            />
          </Box>
        )}

        {(isBackLink || isAiVisibility) && (
          <Box sx={{ marginTop: '16px', ...blogPostStepper?.imgBox }}>
            <img
              draggable={false}
              style={{ objectFit: 'cover' }}
              src={
                process.env.PUBLIC_URL +
                `/static/images/icons/onBoardingGroup.png`
              }
              alt="icon"
              loading="lazy"
            />
          </Box>
        )}

        <Box className="mt-6 mb-1" sx={keywordTrackingUpgradeSx?.buttonBoxSx}>
          {responseMessage?.status && (
            <CommonAlert
              severity={responseMessage?.status}
              message={responseMessage?.message}
              sx={{
                ...UpgradeAgencyPlanModalSxs?.alertSx,
                ...keywordTrackingUpgradeSx?.upgradeToAgencyAlert
              }}
            />
          )}
          <Box sx={keywordTrackingUpgradeSx?.upgradeBtnBoxSx}>
            {!isLocalSeo && !isMapRankTracking && !isAiVisibility && (
              <Button
                variant="contained"
                fullWidth
                sx={keywordTrackingUpgradeSx?.btnSx}
                onClick={() => {
                  if (!isMember) {
                    //handleUpgradeClick();
                    setOpenModal(true);
                    if (isLocalSeo || isMapRankTracking) {
                      setIsLocalSeoUnlock(true);
                    } else if (isBackLink) {
                      setIsBackLinkUnlock(true);
                    } else {
                      setIsKeywordUnlock(true);
                    }
                  }
                }}
                disabled={isMember}
              >
                {loader ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  <>
                    {isBackLink
                      ? keywordTrackingUpgradeTexts?.unlockBackLinkBtn
                      : keywordTrackingUpgradeTexts?.unlockBtn}
                  </>
                )}
              </Button>
            )}
            {(isLocalSeo || isMapRankTracking) && (
              <Button
                variant="contained"
                fullWidth
                sx={LocalSeoAllSx?.oneTimeAddOnBtn}
                onClick={() => {
                  if (!isMember) {
                    //handleUpgradeClick();
                    setOpenModal(true);
                    if (isLocalSeo || isMapRankTracking) {
                      setIsLocalSeoUnlock(true);
                    } else if (isBackLink) {
                      setIsBackLinkUnlock(true);
                    } else {
                      setIsKeywordUnlock(true);
                    }
                  }
                }}
                disabled={isMember}
              >
                {loader ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  <>{localSeoTexts?.oneTimeAddOn}</>
                )}
              </Button>
            )}
            <Button
              variant={isAiVisibility ? 'contained' : 'outlined'}
              fullWidth
              sx={keywordTrackingUpgradeSx?.btnSx}
              onClick={() => {
                if (!isMember) {
                  if (isAiVisibility) {
                    setOpenAiAddonModal(true);
                  } else {
                    setOpenModal(true);
                  }
                  setIsBackLinkUnlock(false);
                  setIsKeywordUnlock(false);
                  setIsLocalSeoUnlock(false);
                }
              }}
              disabled={isMember}
            >
              {loader ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                <>
                  {isAiVisibility
                    ? AiDashboardTexts?.upgradePageBtn
                    : isLocalSeo || isMapRankTracking
                    ? keywordTrackingUpgradeTexts?.confirmUpgrade
                    : localSeoTexts?.upgradePlan}
                </>
              )}
            </Button>
          </Box>
          {(isLocalSeo || isMapRankTracking) && (
            <Typography sx={LocalSeoAllSx?.addonFooter}>
              {localSeoTexts?.addonFooter}
              <span
                style={LocalSeoAllSx?.clickOnLearnMore}
                onClick={() => {
                  openNewTab(LocalSeoInfoBoxTexts?.seoToolsLink);
                }}
              >
                {localSeoTexts?.clickLearnMore}
              </span>
            </Typography>
          )}
          <Box sx={UpgradeAgencyPlanModalSxs?.avatarGroupBoxSx}>
            <Box
              sx={{ flex: 1.4 }}
              className="flex items-center justify-evenly mt-5 md:m-0 flex-col md:flex md:flex-row w-full"
            >
              {/* Google Rating */}
              <div className="flex items-center">
                <Box>
                  <img
                    src={
                      process.env.PUBLIC_URL + `/static/images/icons/google.svg`
                    }
                    alt="icon"
                  />
                </Box>
                <Box>
                  <img
                    src={
                      process.env.PUBLIC_URL + `/static/images/icons/stars.svg`
                    }
                    alt="icon"
                  />
                </Box>
                <Typography sx={styles?.footerTypoSx}>
                  {'4.9 rating'}
                </Typography>
              </div>

              {/* Community  */}
              <Box sx={{ ...styles?.subFooterBoxSx, marginLeft: '0px' }}>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/community.svg`
                  }
                  alt="icon"
                />
                <Typography sx={styles?.footerTypoSx}>
                  {buySearchCreditTexts?.footerTextFirst}
                </Typography>
              </Box>

              {/* Testimonials  */}
              <Box sx={{ ...styles?.subFooterBoxSx, marginLeft: '0px' }}>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/testimonials.svg`
                  }
                  alt="icon"
                />
                <Typography sx={styles?.footerTypoSx}>
                  {buySearchCreditTexts?.footerTextSecond}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      {!isBackLink && !isLocalSeo && !isMapRankTracking && !isAiVisibility && (
        <img
          draggable={false}
          src={
            process.env.PUBLIC_URL +
            `/static/images/icons/${'keyword-tracking'}.png`
          }
          style={{
            width: '100%',
            marginTop: '0rem'
          }}
        />
      )}
      {isLocalSeo && (
        <img
          draggable={false}
          src={
            process.env.PUBLIC_URL +
            `/static/images/icons/local-seo/${
              isPosting
                ? 'local-seo-posting'
                : isLocalSeoTask
                ? 'local-seo-task-upgrade'
                : 'gmb-bg'
            }.png`
          }
          style={{
            width: '100%',
            marginTop: '0rem'
          }}
        />
      )}
      {isMapRankTracking && (
        <img
          draggable={false}
          src={
            process.env.PUBLIC_URL +
            `/static/images/icons/local-seo/map-rank-tracker.png`
          }
          style={{
            width: '100%',
            marginTop: '0rem'
          }}
        />
      )}

      <CommonModal
        open={openModal}
        handCloseModal={handleCloseUpgradeModal}
        title={''}
        closebtn={false}
        isAgencyModal={true}
        isBackLinkUnlock={isBackLinkUnlock}
        isKeywordUnlock={isKeywordUnlock}
        isLocalSeoUnlock={isLocalSeoUnlock}
      >
        <UpgradeAgencyPlanModal
          handleCloseUpgradeModal={handleCloseUpgradeModal}
          isKeywordTracking={
            !isBackLink && !isMapRankTracking && !isAiVisibility
          }
          isBackLink={isBackLink && !isMapRankTracking}
          isBackLinkUnlock={isBackLinkUnlock}
          isKeywordUnlock={isKeywordUnlock}
          isMapRankTracking={isMapRankTracking && !isBackLink}
          isLocalSeoUnlock={isLocalSeoUnlock}
          isLocalSeo={isLocalSeo}
          isPro={isAiVisibility}
        />
      </CommonModal>
      <CommonModal
        open={openAiAddonModal}
        handCloseModal={handleAiAddonModalClose}
        title={''}
        closebtn={false}
        isAgencyModal={true}
        isInfoModal={true}
        isFreeDowngrade={true}
        isDynamicWidth={AIVisibilityAddOnModalWidth}
      >
        <AiVisibilityAddonModal handleClose={handleAiAddonModalClose} />
      </CommonModal>
    </>
  );
};
